import { Component } from '@angular/core';
import { AdminStockList } from "../../../../components/admin-dashboard-component/admin-stock-list/admin-stock-list";
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-view-all-stock',
  imports: [AdminStockList],
  templateUrl: './view-all-stock.html',
  styleUrl: './view-all-stock.scss'
})
export class ViewAllStock {

}
